import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const CreateQuiz = () => {
  const [quizname, setQuizname] = useState("");
  const [quiztype, setQuiztype] = useState("face");
  const [creditlimit, setCreditlimit] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);

    try {
      const response = await axiosPrivate.post(
        "/manager/createquiz",
        JSON.stringify({
          quizname,
          quiztype,
          creditlimit,
        })
      );

      setSuccess(true);
      setQuizname("");
      setQuiztype("face");
      setCreditlimit("");
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 400) {
        setErrMsg("Invalid quiz type or insufficient credits");
      } else if (err?.response?.status === 404) {
        setErrMsg("User not found");
      } else if (err?.response?.status === 500) {
        setErrMsg("Failed to create the quiz session due to an internal error");
      } else {
        setErrMsg(err?.response?.data?.message || err?.message);
      }
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/manager")}
      >
        ← Back to Dashboard
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Create New Quiz
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Set up a new psychometric assessment
        </p>
      </div>

      {/* Messages */}
      {errMsg && <p className="errmsg">{errMsg}</p>}
      {success && (
        <div className="successmsg" style={{ textAlign: "center" }}>
          <p style={{ marginBottom: "1rem" }}>✓ Quiz created successfully!</p>
          <button
            className="btn-primary"
            onClick={() => navigate("/manager")}
            style={{ marginTop: "0.5rem" }}
          >
            View All Quizzes
          </button>
        </div>
      )}

      {/* Form Card */}
      {!success && (
        <div className="card" style={{ padding: "2.5rem" }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="quizname">Quiz Name</label>
              <input
                type="text"
                id="quizname"
                value={quizname}
                onChange={(e) => setQuizname(e.target.value)}
                placeholder="e.g., Q1 2024 Team Assessment"
                required
              />
              <p className="instructions">
                Choose a descriptive name to identify this quiz
              </p>
            </div>

            <div className="form-group">
              <label htmlFor="quiztype">Quiz Type</label>
              <select
                id="quiztype"
                value={quiztype}
                onChange={(e) => setQuiztype(e.target.value)}
                required
                style={{
                  appearance: "none",
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23CBD5E1' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 1rem center",
                  paddingRight: "3rem"
                }}
              >
                <option value="face">FACE Assessment</option>
                <option value="personality">Personality Test</option>
                <option value="aptitude">Aptitude Test</option>
                <option value="custom">Custom Assessment</option>
              </select>
              <p className="instructions">
                Select the type of psychometric assessment
              </p>
            </div>

            <div className="form-group">
              <label htmlFor="creditlimit">Credit Limit</label>
              <input
                type="number"
                id="creditlimit"
                value={creditlimit}
                onChange={(e) => setCreditlimit(e.target.value)}
                placeholder="e.g., 50"
                required
                min="1"
              />
              <p className="instructions">
                Maximum number of participants for this quiz
              </p>
            </div>

            <div style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
              <button type="submit" className="btn-primary" style={{ flex: 1 }}>
                Create Quiz
              </button>
              <button
                type="button"
                className="btn-secondary"
                onClick={() => navigate("/manager")}
                style={{ flex: 1 }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CreateQuiz;
